import React from 'react';
import { FileUploader, Input, InputWithSymbol, Multiselect } from '@cokitchen/cokitchen-components';
import { PartnerFormType } from './types';
import { AddRiderFormType } from '../../add-riders';
import { DeleteIcon } from 'cokitchen-icons';
import { STORAGE_KEYS } from 'utils/constants';

export type RiderFieldType =
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'phone_number'
  | 'profile_image'
  | 'user_gender';

const PartnerFourthStep = ({
  handleAddRiders,
  handleDelete,
  formData
}: {
  handleAddRiders: (e: any, i: any, field: RiderFieldType) => void;
  formData: PartnerFormType | AddRiderFormType;
  handleDelete?: (i: number) => void;
}) => {
  const { riders } = formData;
  const genderOptions = [
    {
      value: 'Male',
      text: 'Male'
    },
    {
      value: 'Female',
      text: 'Female'
    }
  ];
  return (
    <div className='space-y-8'>
      {riders.map(
        ({ first_name, email, last_name, phone_number, profile_image, user_gender }, i) => (
          <div key={i} className='space-y-2 relative pb-4'>
            <div className='grid grid-cols-2 gap-2'>
              <Input
                name='first_name'
                label='First Name'
                placeholder='Jeffery'
                small
                onChange={(e) => handleAddRiders(e, i, 'first_name')}
                value={first_name}
              />
              <Input
                name='last_name'
                label='Last Name'
                placeholder='Williams'
                small
                onChange={(e) => handleAddRiders(e, i, 'last_name')}
                value={last_name}
              />
            </div>
            <Input
              name='email'
              label='Email'
              placeholder="Rider's email"
              small
              onChange={(e) => handleAddRiders(e, i, 'email')}
              value={email}
            />
            <InputWithSymbol
              type='phone'
              symbol='flag'
              name='phone_number'
              label='Mobile no.'
              placeholder='+234 0124 422 333'
              small
              onChange={(e) => handleAddRiders(e, i, 'phone_number')}
              value={phone_number}
            />
            <div>
              <label className='font-medium'>Gender</label>
              <Multiselect
                placeholder='Select Gender'
                isSingle
                values={[user_gender]}
                options={genderOptions}
                onChange={(e) => {
                  handleAddRiders(e[0], i, 'user_gender');
                }}
              />
            </div>
            <div
              className={`pt-3 ${i !== riders.length - 1 && 'border-b border-b-gray-border pb-8'}`}>
              <label className='font-medium'>Add rider image</label>
              <FileUploader
                token={localStorage.getItem(STORAGE_KEYS.TOKEN) as string}
                fileUrls={profile_image ? [profile_image] : []}
                setFileUrls={(files) => handleAddRiders(files[0], i, 'profile_image')}
              />
            </div>
            {riders.length > 1 && (
              <DeleteIcon
                className='bg-red-1 text-red-5 p-[5px] w-6 h-6 rounded-md hover:bg-red-2 transition-all cursor-pointer absolute -top-3 right-0'
                onClick={() => handleDelete?.(i)}
              />
            )}
          </div>
        )
      )}
    </div>
  );
};

export default PartnerFourthStep;
